import React, { Component } from 'react'; 


export default class About extends Component{
    render(){
        return(
            <div id="how-section">
                
                <section id="howto">
                    <h2> How It Works</h2>
                    <p> Search  favorite ingredient of yours to find recipes that use that ingredient.</p>
                </section>
                <section id="screenshot">
                    <h2> Try It Out</h2>
                    <p> Add recipes to your personal cookbook. Compare and alter recipes you find on the web.</p>
                </section>
            </div>

        )
    }
}
            
            
